export const isValidFileType = (type: string | string[], file: File) => {
  // If is array iterates elements
  if (Array.isArray(type)) {
    for (let i = 0; i < type.length; i++) {
      // If is it a match return true
      if (file.type === type[i]) {
        return true;
      }
    }
    return false;
  }

  if (file.type === type) {
    return true;
  }

  return false;
};
